export default {
    benefitsCities: []
  }
  


// WEBPACK FOOTER //
// ./src/store/modules/popupciudad/state.js